// HELPERS
import { stringifyFptiProps } from '@/utils'

// CONSTANTS
import { commonModularProfileFptiProperties } from '@/constants'

// existing experience
export const BUSINESS_PROFILE_PREVIEW_PAGE_SHOWN_FPTI = {
  eventName: 'bp_seller_profile_preview_shown',
}

export const BUSINESS_PROFILE_EDIT_PROFILE_CLICK_FPTI = stringifyFptiProps({
  eventName: 'business_profile_seller_view_edit_profile_click',
})

export const BUSINESS_PROFILE_PREVIEW_PROFILE_CLICK_FPTI = stringifyFptiProps({
  eventName: 'business_profile_seller_view_preview_click',
})

export const BUSINESS_PROFILE_SELLER_SHARE_LINK_CLICK_FPTI = stringifyFptiProps(
  {
    eventName: 'business_profile_seller_view_share_click',
  },
)

// modular experience
export const MODULAR_EDIT_PROFILE_PANEL_EDIT_BUSINESS_INFO_FPTI =
  stringifyFptiProps({
    ...commonModularProfileFptiProperties,
    eventName: 'edit_bp_page_edit_business_info_link_click',
  })
